var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-button',{staticClass:"tw-text-white tw-mt-4 xl:tw-mt-0",attrs:{"to":{
    name: 'NewShipmentAddress',
    params: {
      direction: 'pickup'
    }
  },"variant":"primary"},nativeOn:{"click":function($event){return _vm.refine.apply(null, arguments)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }